import React, { useEffect, useState, useCallback } from "react";
import { makeApi, URLS } from "Utils/apiURL";
import {
  WA_CONNECTION_SUCCESS_MESSAGE,
  WA_CONNECTION_FAILURE_MESSAGE,
  WA_POPUP_DONE_KEY,
  broadcastWaAuth
} from "Pages/Dashboard/settings/ConnectedAccounts/WhatsAppAccounts/waConnectionMessages";

const signalOpenerAndTrySelfClose = () => {
  try {
    window[WA_POPUP_DONE_KEY] = true;
  } catch (e) {
    // ignore
  }
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(WA_CONNECTION_SUCCESS_MESSAGE, window.location.origin);
    }
  } catch (e) {
    // opener often null after Unipile OAuth
  }
  broadcastWaAuth(WA_CONNECTION_SUCCESS_MESSAGE);
  setTimeout(() => {
    try {
      window.close();
    } catch (e) {
      // ignore
    }
  }, 200);
};

const WaSuccess = () => {
  const [status, setStatus] = useState("connecting"); // connecting | success | already_connected | error

  const onCloseClick = useCallback(() => {
    signalOpenerAndTrySelfClose();
    try {
      const o = window.opener;
      if (o) o.focus();
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accountId = params.get("account_id");

    const notifyOpenerAndClose = () => {
      signalOpenerAndTrySelfClose();
    };

    if (!accountId) {
      // No account_id in URL — notify_url callback already handled it
      setStatus("success");
      notifyOpenerAndClose();
      return;
    }

    const confirmConnection = async () => {
      try {
        const config = {
          url: URLS.connectWhatsAppAccount,
          method: "POST",
          data: { accountId }
        };
        const res = await makeApi(config);
        const responseCode = res?.data?.responseCode;
        if (+responseCode === 200) {
          setStatus("success");
          notifyOpenerAndClose();
        } else if (+responseCode === 409) {
          // Already connected (notify_url callback got here first) — still a success
          setStatus("success");
          notifyOpenerAndClose();
        } else {
          setStatus("error");
        }
      } catch (e) {
        setStatus("error");
      }
    };

    confirmConnection();
  }, []);

  if (status === "connecting") {
    return (
      <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
        <h2 style={{ color: "#25D366", marginBottom: "12px" }}>Connecting your WhatsApp account…</h2>
        <p style={{ color: "#555" }}>Please wait, this window will close automatically.</p>
      </div>
    );
  }

  if (status === "error") {
    const dismissError = () => {
      try {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(WA_CONNECTION_FAILURE_MESSAGE, window.location.origin);
        }
      } catch (e) {
        // ignore
      }
      broadcastWaAuth(WA_CONNECTION_FAILURE_MESSAGE);
      try {
        window.close();
      } catch (e) {
        // ignore
      }
      try {
        const o = window.opener;
        if (o) o.focus();
      } catch (e) {
        // ignore
      }
    };
    return (
      <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
        <h2 style={{ color: "#c00", marginBottom: "12px" }}>Connection failed</h2>
        <p style={{ color: "#555", marginBottom: "12px", maxWidth: "360px", marginLeft: "auto", marginRight: "auto" }}>
          Could not save your WhatsApp account. Close this tab with <strong>⌘W</strong> / <strong>Ctrl+W</strong> or use the button below.
        </p>
        <button
          type="button"
          onClick={dismissError}
          style={{ padding: "10px 24px", background: "#666", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "14px" }}
        >
          Close window
        </button>
      </div>
    );
  }

  const closeBtnStyle = {
    padding: "10px 24px",
    background: "#25D366",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    marginTop: "20px"
  };

  return (
    <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
      <h2 style={{ color: "#25D366", marginBottom: "12px" }}>WhatsApp connected successfully!</h2>
      <p style={{ color: "#555", maxWidth: "360px", margin: "0 auto" }}>
        This tab should close automatically. If it does not, use{" "}
        <strong>⌘W</strong> (Mac) or <strong>Ctrl+W</strong> (Windows), or click below.
      </p>
      <button type="button" onClick={onCloseClick} style={closeBtnStyle}>
        Close window
      </button>
    </div>
  );
};

export default WaSuccess;
export { WaSuccess };
